import React from 'react'
import TransactionLogsContainer from 'containers/panel/admin/transaction-logs-container'

const TransactionLogsPage = () => {
  return (
    <TransactionLogsContainer />
  )
}

export default TransactionLogsPage